import {
  NOTIFICATION_TYPE,
  NOTIFICATIONS,
} from '../../auction_manager/notifications';
import { AUCTION_EVENTS } from '../../event_bus_modules/auction_bidding';
import { formatAmount } from './auction_formatter';

const NOTIFICATION_CLASS = {
  [NOTIFICATION_TYPE.SUCCESS]: 'bidding-notification--success',
  [NOTIFICATION_TYPE.WARNING]: 'bidding-notification--warning',
  [NOTIFICATION_TYPE.ERROR]: 'bidding-notification--error',
  active: 'bidding-notification--active',
};

const NOTIFICATION_TYPE_CLASSES = [
  NOTIFICATION_CLASS[NOTIFICATION_TYPE.SUCCESS],
  NOTIFICATION_CLASS[NOTIFICATION_TYPE.WARNING],
  NOTIFICATION_CLASS[NOTIFICATION_TYPE.ERROR],
];

const NOTIFICATION_INPUT_ID = {
  [NOTIFICATIONS.RECONNECTING]: 'reconnecting',
  [NOTIFICATIONS.CONNECTION_LOST]: 'connection_lost',
  [NOTIFICATIONS.RECONNECTED]: 'reconnected',
  [NOTIFICATIONS.CONNECTION_SLOW]: 'connection_slow',
  [NOTIFICATIONS.BID_PROCESSING_ERROR]: 'bid_processing_error',
  [NOTIFICATIONS.PLACE_INCREMENT_ERROR]: 'place_increment_error',
  [NOTIFICATIONS.AUTO_INCREMENT_PLACED]: 'auto_increment_placed',
  [NOTIFICATIONS.AUTO_INCREMENT_PLACED_WHILE_HIGHEST_BIDDER]:
    'auto_increment_placed_while_highest_bidder',
  [NOTIFICATIONS.RETRYING_BID]: 'reattempting',
  [NOTIFICATIONS.INVALID_MAX_BID]: 'invalid_max_bid',
  [NOTIFICATIONS.MAX_BID_MET_OR_EXCEEDED]: 'max_bid_met_or_exceeded',
  [NOTIFICATIONS.UNEXPIRED_AUTO_INCREMENT_ALREADY_EXIST]:
    'unexpired_auto_increment_already_exists',
};

const notificationsWithVariable = [
  NOTIFICATIONS.RETRYING_BID,
  NOTIFICATIONS.INVALID_MAX_BID,
  NOTIFICATIONS.MAX_BID_MET_OR_EXCEEDED,
];

$(() => {
  const biddingNotificationElement = $('.bidding-notification');
  const messageHeaderElement = biddingNotificationElement.find(
    '.bidding-notification__message-header'
  );
  const messageTextElement = biddingNotificationElement.find(
    '.bidding-notification__message-text'
  );
  const biddingNotificationCloseButton = biddingNotificationElement.find(
    '.close-button'
  );

  const displayNotification = ({ notification, type, message = '' }) => {
    const notificationType = NOTIFICATION_CLASS[type];
    let header = '';
    let text = '';

    if (NOTIFICATION_INPUT_ID.hasOwnProperty(notification)) {
      // take message from the predefined options
      const inputId = NOTIFICATION_INPUT_ID[notification];
      const notificationInputElement = $(`input#${inputId}`);
      header = notificationInputElement.attr('data-notification-header');
      text = notificationInputElement.attr('data-notification-text');

      // if notification has variable inside, replace with data provided in message
      if (notificationsWithVariable.includes(notification)) {
        if (notification === NOTIFICATIONS.RETRYING_BID) {
          const attempt = message;
          text = text.replaceAll('[BidAttempt]', attempt);
        } else if (notification === NOTIFICATIONS.INVALID_MAX_BID) {
          const { nextBidAmount } = message;
          const formattedNextBidAmount = formatAmount(nextBidAmount);
          text = text.replaceAll('[NextBidAmount]', formattedNextBidAmount);
        } else if (notification === NOTIFICATIONS.MAX_BID_MET_OR_EXCEEDED) {
          const { cancelAtAmount, lotNumber } = message;
          const formattedCancelAmount = formatAmount(cancelAtAmount);
          text = text
            .replaceAll('[CancelAtAmount]', formattedCancelAmount)
            .replaceAll('[LotNumber]', lotNumber);
        }
      }
    } else {
      header = message;
    }

    biddingNotificationElement.removeClass(NOTIFICATION_TYPE_CLASSES);
    biddingNotificationElement.addClass(NOTIFICATION_CLASS.active);
    biddingNotificationElement.addClass(notificationType);
    messageHeaderElement.text(header);
    messageTextElement.text(text);
  };

  const clearNotification = () => {
    biddingNotificationElement.removeClass(NOTIFICATION_CLASS.active);
    biddingNotificationElement.removeClass(NOTIFICATION_TYPE_CLASSES);
    messageHeaderElement.text('');
    messageTextElement.text('');
  };

  EVENT_BUS.on(
    AUCTION_EVENTS.SHOW_NOTIFICATION,
    ({ notification, message, type }) => {
      displayNotification({ notification, message, type });
    }
  );

  EVENT_BUS.on(AUCTION_EVENTS.CLEAR_NOTIFICATION, clearNotification);

  biddingNotificationCloseButton.on('click', () => {
    EVENT_BUS.dispatch(AUCTION_EVENTS.CLEAR_NOTIFICATION);
  });
});
